import React from "react";
import {
  PATIENT_JOURNEY_STEPS,
  journeyActiveIndexFromWorkflow,
} from "../../utils/patientJourney";
import "./PatientJourneyStrip.scss";

/**
 * Compact horizontal progress strip for Care Price + request surfaces.
 * @param {{ workflow?: string, activeIndex?: number, compact?: boolean }} props
 */
export default function PatientJourneyStrip({
  workflow,
  activeIndex,
  compact = false,
}) {
  const safe =
    activeIndex != null && Number.isFinite(Number(activeIndex))
      ? Math.min(Math.max(0, Number(activeIndex)), PATIENT_JOURNEY_STEPS.length - 1)
      : journeyActiveIndexFromWorkflow(workflow);
  const pct = ((safe + 1) / PATIENT_JOURNEY_STEPS.length) * 100;

  return (
    <div className={`pjStrip${compact ? " pjStrip--compact" : ""}`} aria-label="Care journey progress">
      <div className="pjStrip__track" aria-hidden="true">
        <div className="pjStrip__fill" style={{ width: `${pct}%` }} />
      </div>
      <p className="pjStrip__summary">
        Step {safe + 1} of {PATIENT_JOURNEY_STEPS.length}:{" "}
        <strong>{PATIENT_JOURNEY_STEPS[safe].label}</strong>
      </p>
      <ol className="pjStrip__steps">
        {PATIENT_JOURNEY_STEPS.map((step, index) => {
          const done = index < safe;
          const isActive = index === safe;
          return (
            <li key={step.id} className="pjStrip__item">
              <span
                className={`pjStrip__step${isActive ? " is-active" : ""}${done ? " is-done" : ""}`}
              >
                <span className="pjStrip__labelFull">{step.label}</span>
                <span className="pjStrip__labelShort" aria-hidden="true">
                  {step.short}
                </span>
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
